export interface IntegrationFormState {
    type: string;
    isActive: boolean;
}

export interface PipedriveIntegrationFormState extends IntegrationFormState {
    token: string | null;
    checkActivityAsDone: boolean;
    associateWithDeal: boolean;
}

export interface OpenAiIntegrationFormState extends IntegrationFormState {
    token: string | null;
    model: string | null;
}

export interface MoskitIntegrationFormState extends IntegrationFormState {
    token: string | null;
    activityIds: {
        BUSY: number | null;
        DITCHED: number | null;
        ANSWERED: number | null;
        NO_ANSWER: number | null;
    };
    customFields: {
        value: string | null;
        fieldId: string | null;
        fieldType: string | null;
    };
}
